import { api } from "@/api"

import { useQuery } from "@tanstack/vue-query"

export type MerchantGroupTransactionReportDatapoint =
  DeepReadonly<{
    start: Date
    end: Date
    value: number
  }>

export type MerchantGroupTransactionReport = DeepReadonly<{
  dataset: MerchantGroupTransactionReportDatapoint[]
  granularity: Granularity
}>

const retrieveMerchantGroupTransactionReport =
  async (): Promise<MerchantGroupTransactionReport> => {
    const { body } = await api.get<
      RecursivelyConvertDatesToStrings<MerchantGroupTransactionReport>
    >("/merchant-group/reports/transactions/", {
      isMerchantGroup: true,
    })
    return {
      ...body,
      dataset: body.dataset.map((entry) => ({
        ...entry,
        start: DateFns.parseISO(entry.start),
        end: DateFns.parseISO(entry.end),
      })),
    }
  }

export const useMerchantGroupTransactionReport = () =>
  useQuery(
    [
      BASE_MERCHANT_GROUP_TRANSACTION_REPORT_QUERY_KEY,
    ] as const,
    () => retrieveMerchantGroupTransactionReport(),
    { refetchInterval: 60 * 1000 }
  )
